import { useStableCallback } from "./useStableCallback.mjs";
import { useEffect, useState } from "react";

//#region src/hooks/useInterval.ts
function useInterval(calculateFn, intervalMs) {
	const stableCalculateFn = useStableCallback(calculateFn);
	const [value, setValue] = useState(stableCalculateFn());
	useEffect(() => {
		const intervalId = setInterval(() => {
			setValue(stableCalculateFn());
		}, intervalMs);
		return () => clearInterval(intervalId);
	}, [stableCalculateFn, intervalMs]);
	return value;
}

//#endregion
export { useInterval };